<ng-template
    [ngIf]="showFullButton"
    [ngIfElse]="mobile">
    <button
        mat-button
        class="list-drop-down__button"
        [matMenuTriggerFor]="listDropDownMenu"
        [disabled]="disabled()">
        {{ labelDisplay() }}
        <mat-icon class="material-symbols-outlined">arrow_drop_down</mat-icon>
    </button>
</ng-template>
<ng-template #mobile>
    <button
        mat-icon-button
        class="list-drop-down__button"
        [matMenuTriggerFor]="listDropDownMenu"
        [disabled]="disabled()">
        <mat-icon class="material-symbols-outlined">{{ mobileIcon() }}</mat-icon>
    </button>
</ng-template>
<mat-menu #listDropDownMenu="matMenu">
    <div
        *ngFor="let item of list()"
        mat-menu-item
        [dir]="isRTL"
        (click)="valueChanged(item)">
        {{ item.title }}
    </div>
</mat-menu>
